import React, { Component } from "react";
import * as AF from "aframe";
import * as TWEEN from "@tweenjs/tween.js";

class AFrameApp extends Component {
  componentDidMount() {
    this.aiBinding();
  }

  aiBinding() {
    AF.registerComponent("ai-rotation", {
      schema: {
        enabled: { default: true },
        id: { default: "viewController" },
      },
      init: function() {
        var rotation = this.el.getAttribute("rotation");

        this.now = { pitch: rotation.x, yaw: rotation.y };
        this.past = { pitch: rotation.x, yaw: rotation.y };
        this.target = { pitch: rotation.x, yaw: rotation.y };
        this.dTarget = { pitch: 0, yaw: 0 };
        this.playerFpsDiv = document.getElementById("playerFpsDiv");
        this.rotateTween = null;

        this.lastFpsUpdateT = 0;
        this.position = { x: 0, y: 0 };
      },
      play: function() {
        this.onLookAtPHandler = this.onLookAtP.bind(this);
        window.addEventListener("lookAtP", this.onLookAtPHandler);
      },
      pause: function() {
        window.removeEventListener("lookAtP", this.onLookAtPHandler);
      },
      onLookAtP: function(evt) {
        this.target.pitch = evt.detail.pitch;
        this.target.yaw = evt.detail.yaw;

        this.past = this.now;

        var dYaw = this.target.yaw - this.past.yaw;
        if (Math.abs(dYaw) > 180) {
          dYaw = dYaw > 0 ? dYaw - 360 : 360 + dYaw;
        }
        this.dTarget.yaw = dYaw;
        this.dTarget.pitch = this.target.pitch - this.past.pitch;

        if (this.dTarget.yaw === 0 && this.dTarget.pitch === 0) return;
        TWEEN.removeAll();

        var rotateTween = new TWEEN.Tween(null).to(null, 2000);
        rotateTween.onUpdate(rate => {

          this.el.setAttribute("rotation", {
            x: this.dTarget.pitch * rate + this.past.pitch,
            y: this.dTarget.yaw * rate + this.past.yaw
          });
        });

        rotateTween.easing(TWEEN.Easing.Quartic.Out);

        rotateTween.start();
      },
      tick: function(t, dt) {
        if (t - this.lastFpsUpdateT >= 500) {
          this.playerFpsDiv.innerHTML = `Render: ${Math.floor(1000 / dt)} fps`;
          this.lastFpsUpdateT = Math.floor(t);
        }

        if (!this.data.enabled) {
          return;
        }
        var rotation = this.el.getAttribute("rotation");
        if (!rotation) {
          return;
        }

        this.now = { pitch: rotation.x, yaw: rotation.y };

        TWEEN.update();
      }
    });
  }

  render() {
    return (
      <div id="aframeContainer" style={this.props.hidden? { display: "none" } : {}}>
        <a-scene embedded vr-mode-ui="enabled: false">
          <a-videosphere
            rotation="0 -90 0"
            src="#mainVideo"
            play-on-window-click
            play-on-vrdisplayactivate-or-enter-vr
          />

          <a-camera
            class="aframeCam"
            user-height="0"
            look-controls-enabled={this.props.isMouseMove}
            wasd-controls-enabled="false"
            ai-rotation
          >
          </a-camera>
          <a-assets />
        </a-scene>
      </div>
    );
  }
}
export default AFrameApp;
